import React from 'react';

import { StyleSheet, View } from 'react-native';

import { ZIndex, primitive, spacing } from 'styles/constants';

interface SimplePromoRibbonProps {
  message: React.ReactElement;
}

export const SimplePromoRibbon: React.FC<SimplePromoRibbonProps> = ({ message }) => (
  <View style={styles.ribbonContent}>
    <View style={styles.ribbonWrapper}>{message}</View>
  </View>
);

const styles = StyleSheet.create({
  ribbonContent: {
    zIndex: ZIndex.NORMAL,
    backgroundColor: primitive.$meltyYellow,
    height: spacing.$8,
    alignItems: 'center',
    justifyContent: 'center',
  },
  ribbonWrapper: {
    zIndex: ZIndex.MAX,
    justifyContent: 'center',
    width: '100%',
  },
});
